angular.module('gym.calendar').directive('copyEventWebsiteLink', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/copy_event_website_link.html.slim'),
    scope: {
      event: '=',
      mode: '@'
    },
    controller: ["$scope", "$rootScope", "flash", function($scope, $rootScope, flash) {
      var eventId, gym;
      gym = $rootScope.gym;
      eventId = $scope.event.id;
      $scope.eventWebsiteLink = `${window.location.origin}/websites/${gym.website_domain}/calendar/event/${eventId}`;
      return $scope.onWebsiteLinkCopied = function() {
        return flash.success = "Copied";
      };
    }]
  };
});
